export var ListCountRequestMode;
(function (ListCountRequestMode) {
    ListCountRequestMode["None"] = "None";
    ListCountRequestMode["Exact"] = "Exact";
    ListCountRequestMode["Estimated"] = "Estimated";
})(ListCountRequestMode || (ListCountRequestMode = {}));
export var ListCountEstimateMode;
(function (ListCountEstimateMode) {
    ListCountEstimateMode["Exact"] = "Exact";
    ListCountEstimateMode["Estimated"] = "Estimated";
})(ListCountEstimateMode || (ListCountEstimateMode = {}));
//# sourceMappingURL=paginationSummary.js.map